import React, { useEffect, useRef, useState } from 'react';
import { Navbar, Container } from '@codeparva/ui-components-library';
import { NavBarTypes } from './navBarTypes';
import { navigate } from 'gatsby';
import { NavBarContext } from './hooks/NavBarContext';
import { NavBarVariant } from './navBarHelper';
import { NavBarFacilityDetailsHelper } from './helpers/NavBarFacilityDetailsHelper';
import { FontAwesomeIcon } from '../../../../utilities/iconLoader/FontAwesomeIcon';
import { ThemeContext } from './hooks/themeContext';
import { HEADER_ICON_SIZES } from '../Header/constants';
import { useThemeContext } from './hooks/themeContext';
import { useWindowDimensions } from '../../../../utilities/Dimensions';

export const NavBar = ({
  theme = 'dark',
  locations,
  iconsConfig,
  locationType,
  navLinks,
  LinkWrapper,
  buttonsConfig,
  onSetNavBarHeight,
  locationDetails,
  globalContext,
  logOutHandler,
}: NavBarTypes.INavBarConfig) => {
  const [openNavBar, setOpen] = useState(false);
  const { width } = useWindowDimensions();
  const [dropdown, setDropdown] = useState(true);
  const [openBurger, setopenBurger] = useState(false);
  let [activeComp, setActiveComp] = useState('');
  const navBarRef = useRef<HTMLDivElement>(null);
  const { socialIcons, phoneNumber, facilityDetails } = locations.location;
  const socialIconsandUrls = {
    socialIcons,
  };
  const phoneNumberRedirect = NavBarFacilityDetailsHelper(phoneNumber);

  const handleNavBarFunctions: NavBarTypes.THandleNavBarFunctions = {
    handleNavBarState: (e: React.ChangeEvent<HTMLInputElement>) => {
      setOpen(!openNavBar);
      setActiveComp(e.target.textContent || '');
    },
    handleNavBarStateButton: (e: React.ChangeEvent<HTMLInputElement>) => {
      setOpen(!openNavBar);
      setActiveComp(e.target.textContent || '');
    },

    handleNavBarStateForLogo: (e: React.ChangeEvent<HTMLInputElement>) => {
      setActiveComp(e.target.textContent || '');
    },
    handleNavBarBurgerState: () => {
      setopenBurger(!openBurger);
      setOpen(!openNavBar);
    },
    handleDropDownState: (e: React.ChangeEvent<HTMLInputElement>) => {
      setDropdown(!dropdown);
      setActiveComp(e?.target.textContent || '');
    },
    handleNavBarRef: (text: string) => {
      setActiveComp(text);
    },

    handleReRouting: (e: React.ChangeEvent<HTMLInputElement>) => {
      locationDetails &&
        locationDetails.length > 1 &&
        navigate('/select-location-page');
      setOpen(!openNavBar);
      activeComp = e.target.textContent || '';
      setActiveComp(activeComp);
    },
  };

  const renderPhoneNumberIcon = () => {
    const selectedTheme = useThemeContext();
    const textColor = selectedTheme === 'dark' ? 'primary' : 'white';
    {
      return (
        <Navbar.Item
          href={phoneNumberRedirect}
          className={`navBarPhoneData has-text-${textColor} has-text-weight-bold`}
        >
          <FontAwesomeIcon
            iconClassName={iconsConfig.phoneNumberIcon}
            iconContextProps={{
              className: 'has-text-primary',
              style: {
                fontSize: HEADER_ICON_SIZES.facilityDetailsiconSize,
              },
            }}
          />
          {phoneNumber}
        </Navbar.Item>
      );
    }
  };

  const variantData: NavBarTypes.TVariantDataType = {
    iconsConfig,
    facilityDetails,
    phoneNumber,
    phoneNumberRedirect,
    locationType,
    handleNavBarFunctions,
    openNavBar,
    navLinks,
    LinkWrapper,
    socialIconsandUrls,
    renderPhoneNumberIcon,
    buttonsConfig,
    globalContext,
    logOutHandler,
  };
  const renderNavBar = () => {
    return <NavBarVariant {...variantData} />;
  };
  useEffect(() => {
    function calcHeight() {
      if (onSetNavBarHeight && null !== navBarRef.current) {
        onSetNavBarHeight(navBarRef.current.clientHeight);
      }
    }
    calcHeight();
  }, []);

  useEffect(() => {
    const checkIfClickedOutside = (e: any) => {
      if (
        (openNavBar || openBurger) &&
        navBarRef.current &&
        !navBarRef.current.contains(e.target)
      ) {
        if (openNavBar) {
          setOpen(false);
        } else {
          setopenBurger(false);
        }
      }
    };

    document.addEventListener('mousedown', checkIfClickedOutside);
    return () => {
      document.removeEventListener('mousedown', checkIfClickedOutside);
    };
  }, [openNavBar, openBurger]);

  return (
    <NavBarContext.Provider
      value={{
        variantType: 'header-2',
        handleNavFunctions: handleNavBarFunctions,
        activeComponent: activeComp,
        dropDownState: dropdown,
        widthwindow: width,
        locationDetails,
      }}
    >
      <ThemeContext.Provider value={theme}>
        <div ref={navBarRef} className="navBar">
          <Navbar
            className="navBarContainer"
            style={{
              position: openNavBar ? 'absolute' : 'relative',
              left: openNavBar ? '0' : 'auto',
            }}
          >
            <Container className="my-0">{renderNavBar()}</Container>
          </Navbar>
        </div>
      </ThemeContext.Provider>
    </NavBarContext.Provider>
  );
};
